import { TenderOfferParticipant } from 'types';
import { tenderParticipantStatusTypes } from 'utils/tenderOfferTypes';

type GetNetAmount = {
  participant?: TenderOfferParticipant;
  sharePrice: number;
  retentionPercentage: number;
};

export const getNetAmount = ({
  participant,
  sharePrice,
  retentionPercentage,
}: GetNetAmount): number => {
  if (!participant) return 0;

  if (participant.status === tenderParticipantStatusTypes.ACCEPTED.value) {
    const grossAmount = participant.totalAccepted * sharePrice;
    const retentionAmount = (grossAmount * retentionPercentage) / 100;
    return grossAmount - retentionAmount;
  }

  return 0;
};
